module.exports = __webpack_public_path__ + "static/media/0023_IMG_LE_SOL_MEGALITH_MEGABROWN.02822fc4.webp";